<div
    class="sai-confirm"
    [class.sai-confirm--dismissible]="data.dismissible">

    <!-- Dismiss -->
    <ng-container *ngIf="data.dismissible">
        <button
            type="button"
            class="sai-confirm__dismiss"
            mat-icon-button
            [attr.aria-label]="data.actions.cancel.label || 'Close'"
            [matDialogClose]="undefined">
            <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </button>
    </ng-container>

    <!-- Content -->
    <div class="sai-confirm__body">

        <!-- Icon: decorative, the title already carries the meaning -->
        <ng-container *ngIf="data.icon.show">
            <div
                class="sai-confirm__icon"
                [ngClass]="'sai-confirm__icon--' + data.icon.color"
                aria-hidden="true">
                <mat-icon [svgIcon]="data.icon.name"></mat-icon>
            </div>
        </ng-container>

        <ng-container *ngIf="data.title || data.message">
            <div class="sai-confirm__text">

                <!-- Title -->
                <ng-container *ngIf="data.title">
                    <h2
                        class="sai-confirm__title"
                        [id]="titleId"
                        [innerHTML]="data.title"></h2>
                </ng-container>

                <!-- Message -->
                <ng-container *ngIf="data.message">
                    <p
                        class="sai-confirm__message"
                        [id]="messageId"
                        [innerHTML]="data.message"></p>
                </ng-container>
            </div>
        </ng-container>

    </div>

    <!-- Actions -->
    <ng-container *ngIf="data.actions.confirm.show || data.actions.cancel.show">
        <div class="sai-confirm__actions">

            <!-- Cancel -->
            <ng-container *ngIf="data.actions.cancel.show">
                <button
                    type="button"
                    mat-stroked-button
                    [matDialogClose]="'cancelled'">
                    {{data.actions.cancel.label}}
                </button>
            </ng-container>

            <!-- Confirm: account gradient, or the danger token for a destructive one -->
            <ng-container *ngIf="data.actions.confirm.show">
                <button
                    type="button"
                    mat-flat-button
                    [ngClass]="confirmClass"
                    [matDialogClose]="'confirmed'">
                    {{data.actions.confirm.label}}
                </button>
            </ng-container>

        </div>
    </ng-container>

</div>
